import { useAppDispatch, useAppSelector } from "../store/hooks"
import { selectCurrentProjectState } from "../store/projects/selectors"
import { useEffect } from "react"
import { changeProject } from "../store/users/thunks"
import { startApp } from "../store/config/thunks"

export const useProjectStarter = () => {
    const projectState = useAppSelector(selectCurrentProjectState)
    const dispatch = useAppDispatch()

    useEffect(() => {
        ;(async () => {
            const selectingProjectId = localStorage.getItem("selectingProjectId")

            if (selectingProjectId) {
                await dispatch(changeProject(selectingProjectId))
                localStorage.removeItem("selectingProjectId")
            }

            if (!projectState.data) {
                dispatch(startApp())
            }
        })()
    }, [projectState.data])
}
